document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.contact-form');
  if (!forms.length) return;

  forms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);

      try {
        if (typeof gtag === 'function') {
          gtag('event', 'ep_formulaire_contact', {
            form_name: 'contact_form',
            request_type: formData.get('contact[request_type]') || '',
            page_location: window.location.href
          });
        }

      } catch (error) {
        console.error('Erreur envoi Zapier :', error);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const telLink = e.target.closest('a[href^="tel:"]');

    if (!telLink) return;

    const phoneNumber = telLink.getAttribute('href').replace('tel:', '').trim();

    if (typeof gtag === 'function') {
      gtag('event', 'ep_clic_telephone', {
        phone_number: phoneNumber,
        link_url: telLink.href,
        link_text: telLink.textContent.trim(),
        page_location: window.location.href
      });

      console.log('Événement GA4 téléphone envoyé', phoneNumber);
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const subscribeLink = e.target.closest('a[href^="https://investisseurs.mymarguerit.com/souscrire/"]');

    if (!subscribeLink) return;

    if (typeof gtag === 'function') {
      gtag('event', 'ep_clic_souscrire', {
        link_url: subscribeLink.href,
        link_text: subscribeLink.textContent.trim(),
        page_location: window.location.href
      });

      console.log('Événement GA4 simulation envoyé');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const subscribeLink = e.target.closest('a[href^="https://calendly.com/"]');

    if (!subscribeLink) return;

    if (typeof gtag === 'function') {
      gtag('event', 'ep_clic_calendly', {
        link_url: subscribeLink.href,
        link_text: subscribeLink.textContent.trim(),
        page_location: window.location.href
      });

      console.log('Événement GA4 simulation envoyé');
    }
  });
});